import { TimetableList } from './pages';
import Paths from './paths';
import { default as Translations } from './lang/hu';

const name = 'timetable';

const icon = 'fa-calendar-alt';

export default {
    pages: {
        TimetableList,
    },
    paths: {
        ...Paths,
    },
    translations: {
        ...Translations,
    },
    name,
    icon,
};

export { default as Paths } from './paths';



// WEBPACK FOOTER //
// ./src/modules/Timetable/index.ts